"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = void 0;
var _react = _interopRequireDefault(require("react"));
var _loadersAndSpinners = require("@kyruus/loaders-and-spinners");
var _Loading = require("./Loading.styles");
var _propTypes = require("prop-types");
const Loading = _ref => {
  let {
    msg = "Validating the patient's response"
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Loading.LoadingContainer, null, /*#__PURE__*/_react.default.createElement(_loadersAndSpinners.FadingLinesSpinner, null), /*#__PURE__*/_react.default.createElement(_Loading.Msg, null, msg));
};
exports.Loading = Loading;
Loading.propTypes = {
  msg: _propTypes.string
};
Loading.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Loading",
  "props": {
    "msg": {
      "defaultValue": {
        "value": "\"Validating the patient's response\"",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};